import { ContentExternalDocumentTypeEnum, ContentTypeEnum } from 'features/contents';
import { ProductTypeEnum } from 'features/products';

export enum SearchResultTypeEnum {
  Product = 1,
  ProductClass = 2,
  ProductClassTimeline = 3,
  Content = 4,
  PracticeExam = 5,
  AnalysisReport = 6,
}

export interface SearchState {
  searchLoading: boolean;
  searchOpened: boolean;
  cleared: string | null;
  searched: boolean;
  showResults: boolean;
  results: GlobalSearchResponse[];
  searchText: string;

  searchId?: string;
  currentPage?: number;
  totalPages?: number;
  totalResults?: number;
  limitPerPage?: number;
}

export interface GlobalSearchResponse {
  searchResultType?: SearchResultTypeEnum;

  productOrganizationUuid?: string;

  productType?: ProductTypeEnum;
  productUuid?: string;
  productSlug?: string;
  productName?: string;
  productDescription?: string;

  productClassUuid?: string;
  productClassDescription?: string;

  contentType?: ContentTypeEnum;
  externalDocumentType?: ContentExternalDocumentTypeEnum;
  contentUuid?: string;
  contentName?: string;
  contentDescription?: string;

  productClassTimelineUuid?: string;
  productClassTimelineName?: string;
  productClassTimelineDescription?: string;

  practiceExamUuid?: string;
  practiceExamName?: string;
  practiceExamDescription?: string;

  analysisReportUuid?: string;
  analysisReportName?: string;
  analysisReportDownloadUuid?: string;
  analysisReportDownloadName?: string;

  commentContentUuid?: string;
  checkinLiveMeetingUuid?: string;
}

export interface GlobalSearchResponseCollection {
  results: GlobalSearchResponse[];
  searchText: string;

  searchId?: string;
  currentPage?: number;
  totalPages?: number;
  totalResults?: number;
  limitPerPage?: number;
}
